import {pdf} from '@react-pdf/renderer';
import PrintDocument from "../bvcomponents/popups/printPopup/printDocument";

import store from './../store';
import * as types from "./actionTypes";
import {convertImgToBase64URL, THUMBNAIL_SIZES} from "../misc/utils";
import {getFabricatorLogo} from "../misc/fabricatorHardcode";
import {featureThumbnailUrl} from "../misc/helpers";

export const getCurrentReceipt = async (assignQuotePopupNewCustomer, newEmployeeSelected) => {

  const {userState, serverState, fabricatorState, cartState, quotesState, priceWorksheetState,
    filterState, assignQuoteState, wizardState, sqftSlabState} = store.getState();

  const {assignQuotePopupCustomer, assignQuotePopupEmployee} = assignQuoteState;

  const printLogo = await convertImgToBase64URL(getFabricatorLogo(fabricatorState));
  let cartItemsThumbnails = {};
  if (fabricatorState.settings.showCartItemThumbnailsInReceipt) {
    for (const cartItem of cartState.cartItems) {
      const thumbnailUrl = featureThumbnailUrl(cartItem.cartFeature, THUMBNAIL_SIZES.small);
      cartItemsThumbnails[cartItem.id] = await convertImgToBase64URL(thumbnailUrl);
    }
  }

  return pdf(PrintDocument({
    fabricatorData: fabricatorState,
    userInfo: userState.userInfo,
    quotes: quotesState.quotes,
    cartItems: cartState.cartItems,
    discountSections: priceWorksheetState.discountSections,
    assignQuotePopupCustomer: assignQuotePopupNewCustomer || assignQuotePopupCustomer,
    employeeSelected: newEmployeeSelected || assignQuotePopupEmployee,
    locale: serverState.language,
    filterGroups: filterState.filterGroups,
    activeTheme: serverState.activeTheme,
    jobId: serverState.jobId,
    printLogo,
    wizardState,
    sqftSlabState,
    cartItemsThumbnails,
  }))
}

export const getCurrentReceiptPages = async () => {
  try {
    const pdfReceipt = await getCurrentReceipt();
    if (pdfReceipt && pdfReceipt.container && pdfReceipt.container.render) {
      await pdfReceipt.container.render();
      if (pdfReceipt.container.document && pdfReceipt.container.document.getLayoutData) {
        const layoutData = pdfReceipt.container.document.getLayoutData();
        if (layoutData && Array.isArray(layoutData.children) && layoutData.children.length) {
          return layoutData.children.length
        }
      }
    }
    return 0
  } catch (e) {
    console.log("error rendering pdf receipt", e);
    return 0
  }
}

export const printReceipt = async () => {
  const pdfReceipt = await getCurrentReceipt();
  const receipt = await pdfReceipt.toBlob();
  const fileURL = URL.createObjectURL(receipt);
  window.open(fileURL, "_blank");
}

export const setReceiptUrl = (receiptUrl) => ({
  type: types.SET_RECEIPT_URL,
  payload: {receiptUrl}
})
